/* ==========================================================================
   OMNI Quiz Vol. 4 - shared engine for the Energy / GLP-1 / Men funnels.
   A funnel config (window.OMNI_QUIZ_V4_FUNNELS[id]) supplies the copy and
   steps; this file renders every screen, handles navigation + branching,
   computes the Depletion Score / protocol and renders R1-R7 + checkout.
   Scoring source of truth: "OMNI Quiz Funnels - Scoring & Personalization v4".
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- store (products wired later - placeholders from the funnel doc) ---------- */
  var STORE = {
    url: 'https://omnicreatine.com',
    currency: '$',
    promoMinutes: 15,
    servingGrams: 3,
    /* OMNI Creatine Gummy (omni-creatine-gummy) - the same product, subscription plans and discount
       codes as the quiz-pdp buy box (landing_page_config "homepage-price"):
       1x $67 - 1x-Pouch $29 = $38 · 2x $134 - 2x-Pouch $60 = $74 · 3x $200 - 3x-Pouch $93 = $107 */
    packs: {
      '1x': { watermelon: '47422824218865', peach: '47565447037169', code: '1x-Pouch' },
      '2x': { watermelon: '47422824251633', peach: '47565447069937', code: '2x-Pouch' },
      '3x': { watermelon: '47422824284401', peach: '47565447102705', code: '3x-Pouch' }
    },
    /* what each card adds (selling plans are per pack size: a 3x plan cannot go on a 2x variant):
       1st card: 1x, every 4 weeks ("Subscribe and Save - 1x VERSION")
       2nd card: 3x, every 12 weeks ("Subscribe and Save - 3x VERSION")
       3rd card: 6 × 1x, every 24 weeks ("Subscribe and Save - 1x VERSION") */
    cards: {
      p1: { pack: '1x', plan: '5314117873', qty: 1 },
      p2: { pack: '3x', plan: '5314085105', qty: 1 },
      p3: { pack: '1x', plan: '5778178289', qty: 6, code: '6x-Pouch' } /* 6x-Pouch: −$199 on 6 × 1x → $203 */
    },
    landingConfig: 'homepage-price',
    plans: {
      p1: { title: '1-month supply', desc: 'Ideal for trying it out', price: 38, compare: 67, servings: 30, perDay: '1.27', packs: 1 },
      p2: { title: '3-month supply', desc: 'For full saturation & lasting results', price: 107, compare: 200, servings: 90, perDay: '1.19', packs: 3, banner: 'Best value', bannerTone: 'blue', gift: true, best: true },
      p3: { title: '6-month supply', desc: 'Ideal for trying it out', price: 203, compare: 402, servings: 180, perDay: '1.12', packs: 6, banner: 'Most popular · Save 45%', bannerTone: 'red', gift: true }
    },
    reco: {
      p3: ['6-month plan', 'Full muscle saturation + lasting results'],
      p2: ['3-month plan', 'To build the daily routine'],
      p1: ['1-month plan', 'Try it and feel the first changes']
    }
  };

  /* ---------- inline icons ---------- */
  var ICON = {
    planCheck: '<svg class="bq-plan-check" viewBox="0 0 24 24" aria-hidden="true"><path fill="#239627" fill-rule="evenodd" clip-rule="evenodd" d="M15.663 3.77915C13.8902 2.98926 11.9096 2.79357 10.0166 3.22128C8.12351 3.649 6.41942 4.67719 5.15845 6.15252C3.89749 7.62785 3.14721 9.47126 3.01951 11.4078C2.89181 13.3444 3.39354 15.2704 4.44987 16.8985C5.50619 18.5266 7.06051 19.7697 8.88102 20.4423C10.7015 21.1149 12.6907 21.1809 14.5518 20.6307C16.413 20.0804 18.0464 18.9432 19.2084 17.3888C20.3705 15.8344 20.9989 13.9459 21 12.0052V11.0857C21 10.5334 21.4477 10.0857 22 10.0857C22.5523 10.0857 23 10.5334 23 11.0857V12.0057C22.9986 14.3778 22.2306 16.6864 20.8103 18.5863C19.39 20.4862 17.3936 21.876 15.1189 22.5486C12.8442 23.2211 10.413 23.1404 8.18792 22.3183C5.96285 21.4963 4.06312 19.977 2.77206 17.9871C1.48099 15.9971 0.86777 13.6432 1.02384 11.2762C1.17992 8.90932 2.09693 6.65625 3.63811 4.85308C5.17929 3.0499 7.26206 1.79322 9.57581 1.27046C11.8896 0.747696 14.3103 0.986866 16.477 1.9523C16.9815 2.17708 17.2082 2.76825 16.9834 3.27272C16.7587 3.7772 16.1675 4.00393 15.663 3.77915ZM22.7068 3.29254C23.0975 3.68287 23.0978 4.31603 22.7075 4.70675L12.7075 14.7168C12.52 14.9044 12.2656 15.0099 12.0003 15.01C11.7349 15.0101 11.4805 14.9047 11.2929 14.7171L8.29289 11.7171C7.90237 11.3266 7.90237 10.6934 8.29289 10.3029C8.68342 9.91237 9.31658 9.91237 9.70711 10.3029L11.9996 12.5954L21.2925 3.29325C21.6829 2.90253 22.316 2.90221 22.7068 3.29254Z"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12ZM17 12C17 12.5523 16.5523 13 16 13H10.4142L12.7071 15.2929C13.0976 15.6834 13.0976 16.3166 12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289C13.0976 7.68342 13.0976 8.31658 12.7071 8.70711L10.4142 11H16C16.5523 11 17 11.4477 17 12Z"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM7 12C7 11.4477 7.44772 11 8 11H13.5858L11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L13.5858 13H8C7.44772 13 7 12.5523 7 12Z"/></svg>',
    tick: '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="#F1F5F9" fill-rule="evenodd" clip-rule="evenodd" d="M13.8047 3.5286C14.0651 3.78894 14.0651 4.21105 13.8047 4.4714L6.4714 11.8047C6.21106 12.0651 5.78894 12.0651 5.5286 11.8047L2.19526 8.4714C1.93491 8.21106 1.93491 7.78894 2.19526 7.5286C2.45561 7.26825 2.87772 7.26825 3.13807 7.5286L6 10.3905L12.8619 3.5286C13.1223 3.26825 13.5444 3.26825 13.8047 3.5286Z"/></svg>',
    spin: '<svg class="bq-spin" viewBox="0 0 24 24" aria-hidden="true"><g stroke="#fff" stroke-width="2" stroke-linecap="round"><path d="M12 2v4" opacity="1"/><path d="M19.07 4.93l-2.83 2.83" opacity=".35"/><path d="M22 12h-4" opacity=".45"/><path d="M19.07 19.07l-2.83-2.83" opacity=".55"/><path d="M12 22v-4" opacity=".65"/><path d="M4.93 19.07l2.83-2.83" opacity=".75"/><path d="M2 12h4" opacity=".85"/><path d="M4.93 4.93l2.83 2.83" opacity=".95"/></g></svg>',
    dot: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="12" fill="#DCE6F0" fill-opacity=".1"/><circle cx="12" cy="12" r="6" fill="#BED1E4"/></svg>',
    codeOk: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#239627" fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM17.2071 9.70711C17.5976 9.31658 17.5976 8.68342 17.2071 8.29289C16.8166 7.90237 16.1834 7.90237 15.7929 8.29289L10.5 13.5858L8.20711 11.2929C7.81658 10.9024 7.18342 10.9024 6.79289 11.2929C6.40237 11.6834 6.40237 12.3166 6.79289 12.7071L9.79289 15.7071C10.1834 16.0976 10.8166 16.0976 11.2071 15.7071L17.2071 9.70711Z"/></svg>'
  };

  /* driver → icon asset key (the Figma set ships four; the rest reuse the closest one) */
  var DRIVER_ICON = {
    hormones: 'strength', childhood: 'dieting', lowt: 'strength', body25: 'strength',
    appetite: 'protein', hunger: 'diet', yoyo: 'dieting', plateau: 'battery', cravings: 'diet',
    alcohol: 'caffeine', water: 'shake', plant: 'dieting', lowdiet: 'diet', strength: 'strength',
    sleep: 'sleep', glp: 'syringe', protein: 'protein', age: 'decline', glplist: 'syringe',
    crash: 'battery', fog: 'fog', ok: 'guarantee'
  };

  var AREAS = {
    female: [
      { key: 'face', label: 'Face', x: 40, y: 8, mx: 40, my: 14 },
      { key: 'arms', label: 'Arms', x: -151, y: 102, mx: -138, my: 136 },
      { key: 'stomach', label: 'Stomach', x: 75, y: 129, mx: 80, my: 155 },
      { key: 'hips', label: 'Hips & Thighs', x: 47, y: 266, mx: 46, my: 276 },
      { key: 'whole', label: 'Whole Body', x: -189, y: 357, mx: -167, my: 369 }
    ],
    male: [
      { key: 'face', label: 'Face', x: 40, y: 8, mx: 40, my: 14 },
      { key: 'chest', label: 'Chest', x: 72, y: 66, mx: 72, my: 76 },
      { key: 'arms', label: 'Arms', x: -151, y: 102, mx: -138, my: 124 },
      { key: 'stomach', label: 'Abdomen', x: 75, y: 124, mx: 80, my: 134 },
      { key: 'love', label: 'Love handles', x: -210, y: 176, mx: -186, my: 186 },
      { key: 'whole', label: 'Whole Body', x: -189, y: 357, mx: -167, my: 369 }
    ]
  };

  var AREA_COPY = {
    face: 'Creatine doesn’t target the face directly, but improved hydration and reduced inflammation show up in the skin.',
    chest: 'Pressing strength typically rises 5-10% in the first month on creatine.',
    arms: 'Arms show creatine results first: more water inside the muscle cell = fuller, firmer arms within 2-3 weeks.',
    stomach: 'Core and abdominal muscles respond fast to creatine + daily movement; lean mass here tightens the midsection.',
    love: 'Creatine raises training output so you burn more per session - the fastest route to losing the handles.',
    hips: 'The biggest muscles in the body - and the biggest creatine reservoir. Loading them lifts your resting metabolism.',
    whole: 'Total-body creatine saturation supports every muscle group and the brain.'
  };

  var TRIED_COPY = {
    'Dieting / calorie counting': ['dieting', 'Dieting', 'Cuts muscle along with fat; creatine protects the muscle.'],
    'Intermittent fasting': ['diet', 'Intermittent fasting', 'Long fasts pull from lean mass; creatine helps you hold on to it.'],
    'More cardio': ['fire', 'More cardio', 'Burns calories but erodes lean mass; creatine offsets that.'],
    'Protein shakes': ['shake', 'Protein shakes', 'Builds muscle only if the energy to train is there - creatine supplies that energy.'],
    'Fat burners / supplements': ['caffeine', 'Fat burners', 'Stimulants borrow energy and crash later - they do nothing for muscle.'],
    'Creatine powder (quit - taste / bloating)': ['scoop', 'Creatine powder', 'Right molecule, wrong format - 5g scoops cause bloating, and most people quit within a month.'],
    'Pre-workout': ['bolt', 'Pre-workout', 'Stimulants mask fatigue for one session; no long-term change.'],
    'TRT / test boosters': ['syringe', 'TRT / boosters', 'Prescription-only or unproven; muscle is the natural lever.'],
    'More caffeine': ['caffeine', 'Caffeine', 'Borrows energy, crashes later, does nothing for muscle.']
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    var F = (window.OMNI_QUIZ_V4_FUNNELS || {})[root.getAttribute('data-funnel')];
    if (!F) return;

    var cfgEl = root.querySelector('[data-bq-assets]');
    var A = {};
    try { A = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { A = {}; }
    var img = function (k) { return (A.images || {})[k] || ''; };
    var icon = function (k) { return (A.icons || {})[k] || ''; };
    var BODY = window.OMNI_QUIZ_V4_BODY || {};

    var app = root.querySelector('[data-bq-app]');
    var live = root.querySelector('[data-bq-live]');

    var POST = [
      { type: 'post', id: 'p1' }, { type: 'post', id: 'p2' }, { type: 'post', id: 'p3' },
      { type: 'post', id: 'p4' }, { type: 'post', id: 'p5' }, { type: 'post', id: 'p6' },
      { type: 'post', id: 'p7' }, { type: 'checkout', id: 'checkout' }
    ];
    var COUNTED = { single: 1, multi: 1, bodymap: 1, info: 1, height: 1, weight: 1 };

    var answers = {};
    var step = -1;
    var units = 'imperial';
    var results = null;
    var flavor = 'watermelon';
    var loaderTimer = null;
    var promoTimer = null;
    var busy = false;

    /* ---------- flow ---------- */
    function visible() {
      var list = F.steps.filter(function (s) { return !s.hidden && (!s.showIf || s.showIf(answers)); });
      return answers.email ? list.concat(POST) : list;
    }
    function current() { return step < 0 ? null : visible()[step]; }
    function stepById(id) {
      for (var i = 0; i < F.steps.length; i++) if (F.steps[i].id === id) return F.steps[i];
      return null;
    }

    function go(idx, push) {
      var list = visible();
      step = Math.max(-1, Math.min(idx, list.length - 1));
      if (push !== false) {
        try { history.pushState({ bq: step }, ''); } catch (e) {}
      }
      render();
    }
    function next() { go(step + 1); }
    function back() {
      var list = visible();
      var i = step - 1;
      while (i >= 0 && list[i] && list[i].type === 'loader') i--;
      go(i);
    }

    window.addEventListener('popstate', function (e) {
      var s = e.state && typeof e.state.bq === 'number' ? e.state.bq : -1;
      if (current() && current().type === 'loader') return;
      step = Math.max(-1, Math.min(s, visible().length - 1));
      if (step >= 0 && visible()[step].type === 'loader') step--;
      render();
    });

    /* ---------- tracking ---------- */
    /* GA4 is loaded with gtag.js, which only reads gtag-style pushes (arguments objects): a GTM-style
       { event: ... } object never reaches GA4. Same path as the vol2/vol3 quizzes: the theme's
       window.omniTrack (assets/omni-track.js: GA4 + Shopify customer events + Clarity), with the same
       fallback inline if that script is missing. Klaviyo only gets the completed-quiz event (pushLead). */
    var dlQueue = [], dlTimer = null, dlTicks = 0;
    function gtagArgs() { return arguments; }
    function gaConfigured() {
      var dl = window.dataLayer;
      if (!dl) return false;
      for (var i = 0; i < dl.length; i++) if (dl[i] && dl[i][0] === 'config') return true;
      return false;
    }
    function pushDataLayer(args) {
      window.dataLayer = window.dataLayer || [];
      if (gaConfigured()) { window.dataLayer.push(args); return; }
      dlQueue.push(args);
      if (dlTimer) return;
      dlTimer = setInterval(function () {
        dlTicks++;
        if (!gaConfigured()) {
          if (dlTicks < 150) return;
          clearInterval(dlTimer); dlTimer = null; dlQueue.length = 0;
          return;
        }
        clearInterval(dlTimer); dlTimer = null;
        while (dlQueue.length) window.dataLayer.push(dlQueue.shift());
      }, 200);
    }
    var lastStepAt = null;
    var previewJump = false; /* ?bq_step=… test link: never report its sample answers */
    function track(ev, props) {
      if (previewJump) return;
      var cs = current();
      var payload = {
        quiz_id: 'vol4_' + F.id, quiz_name: F.name, quiz_variant: 'vol4_' + F.id, funnel: F.id,
        step_index: step, step_id: cs ? cs.id : 'landing'
      };
      if (ev === 'quiz_step_viewed') {
        var now = Date.now();
        if (lastStepAt !== null) payload.step_ms = now - lastStepAt;
        lastStepAt = now;
      }
      Object.keys(props || {}).forEach(function (k) { payload[k] = props[k]; });
      if (typeof window.omniTrack === 'function') { try { window.omniTrack(ev, payload); } catch (e) {} return; }
      try {
        pushDataLayer(gtagArgs('event', ev, payload));
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(ev, payload);
        if (typeof window.clarity === 'function') window.clarity('event', ev);
      } catch (e) {}
    }

    function label(id, v) {
      var st = stepById(id);
      if (!st || !st.opts) return v;
      if (Array.isArray(v)) return v.map(function (i) { return st.opts[i]; }).join(', ');
      return typeof v === 'number' ? st.opts[v] : v;
    }

    function pushLead() {
      var props = { quiz_funnel: F.id }, a = liveAnswers();
      Object.keys(a).forEach(function (k) {
        var v = a[k];
        props['quiz_' + k] = (v && typeof v === 'object' && !Array.isArray(v)) ? JSON.stringify(v) : label(k, v);
      });
      if (results) { props.quiz_tier = results.tier; props.quiz_score = results.score; props.quiz_plan = results.plan; }
      props.quiz_source = F.name;
      props.quiz_variant = 'vol4_' + F.id;
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        try {
          /* answers go on the profile too (like vol3), so Klaviyo segments can use them, not only flows */
          var profile = { email: answers.email };
          Object.keys(props).forEach(function (k) { profile[k] = props[k]; });
          window.klaviyo.push(['identify', profile]);
          window.klaviyo.push(['track', 'OMNI Quiz Completed', props]);
        } catch (e) {}
      }
    }

    /* ---------- scoring (v4) ---------- */
    function noneIdx(id) { var st = stepById(id); return st && st.none ? st.none : []; }
    /* answers minus steps the current branch hides - going back and switching e.g. "meds"
       to "No" must not leave the old medication picks in the score, drivers or profile */
    function liveAnswers() {
      var a = {};
      Object.keys(answers).forEach(function (k) { a[k] = answers[k]; });
      F.steps.forEach(function (s) { if (s.showIf && !s.showIf(answers)) delete a[s.id]; });
      return a;
    }
    function picked(id) {
      var v = liveAnswers()[id];
      if (!Array.isArray(v)) return [];
      var none = noneIdx(id);
      return v.filter(function (i) { return none.indexOf(i) === -1; });
    }

    function computeResults() {
      var a = liveAnswers();
      var score = 0;
      function add(k, map) { var v = a[k]; if (typeof v === 'number' && map[v] != null) score += map[v]; }
      add('diet', [0, 1, 2, 3]); add('train', [2, 1, 0, 0]); add('sleep', [2, 1, 0, 0]);
      add('age', F.id === 'men' ? [0, 0, 1, 2] : [0, 0, 1, 2, 3, 3]);
      add('energy', [3, 2, 1, 0]); add('drive', [3, 2, 1, 0]); add('protein', [3, 2, 1, 0]);
      add('howlong', [0, 1, 2, 3]); add('gained', [2, 0]); add('changed', [2, 0]);
      add('wlhow', [0, 1, 2, 3]); add('childhood', [3, 2, 1, 1]);
      add('hunger', F.id === 'glp1' ? [3, 2, 1, 0] : [2, 2, 2, 0]);
      add('body25', [1, 1, 2, 1]); add('rebound', [2, 3, 2, 1]); add('plateau', [2, 1, 0]);
      add('athletic', [2, 1, 0]); add('alcohol', [0, 1, 2, 3]); add('meals', [2, 1, 1, 0]); add('water', [2, 1, 0]);
      ['symptoms', 'changes', 'physical', 'struggles', 'mood', 'habits', 'hormones', 'lowt'].forEach(function (k) { score += picked(k).length; });
      var glpMed = Array.isArray(a.medlist) && a.medlist.indexOf(0) !== -1;
      if (glpMed) score += 3;
      if (F.id === 'glp1') score += 3;

      var tier = score >= 11 ? 'high' : score >= 5 ? 'medium' : 'low';
      var w = a.weight || { current: 75, goal: 70, units: units };
      var delta = Math.round((w.current - w.goal) * 10) / 10;
      var lbs = (w.units || units) === 'imperial';
      var fmt = function (kg) { return lbs ? Math.round(kg * 2.2046) + ' lb' : Math.round(kg) + ' kg'; };
      var plant = a.diet === 3;
      var glp = F.id === 'glp1' || glpMed;
      var weeks = tier === 'high' || plant || glp ? 12 : tier === 'medium' ? 8 : 4;
      var plan = weeks >= 12 ? 'p3' : weeks >= 8 ? 'p2' : 'p1';
      var dose = w.current >= 90 ? 2 : 1;
      results = {
        score: score, tier: tier, weeks: weeks, plan: plan, dose: dose, delta: delta, fmt: fmt,
        current: w.current, goalW: w.goal, plant: plant, glp: glp,
        goal: F.results.goal(delta, fmt)
      };
    }

    function drivers() {
      var a = liveAnswers(), d = [];
      var has = function (id, i) { var v = a[id]; return Array.isArray(v) ? v.indexOf(i) !== -1 : v === i; };
      if (picked('hormones').length) d.push(['hormones', 'Hormonal headwinds', 'Estrogen shifts accelerate muscle loss and slow the metabolism. You can’t control the hormones - you can control the muscle, and creatine is one of the best-studied ways to keep it.']);
      if (a.childhood === 0 || a.childhood === 1) d.push(['childhood', 'A lifelong set point', 'Your body has defended a higher weight since childhood. That makes crash diets backfire - and makes protecting calorie-burning muscle the smarter path down.']);
      if (picked('lowt').length) d.push(['lowt', 'The fat-testosterone loop', 'Extra fat converts testosterone to estrogen, which makes it easier to gain fat and harder to keep muscle. Rebuilding muscle while losing fat is how you break the loop naturally.']);
      if (a.body25 === 2) d.push(['body25', 'A set point that moved early', 'You’ve been carrying extra since your 20s - your metabolism has adapted to it. More muscle is the most reliable way to move it back.']);
      if (F.id === 'glp1' && (a.hunger === 0 || a.hunger === 1)) d.push(['appetite', 'Appetite near zero', 'With hunger switched off, protein and creatine intake collapse - and the body starts pulling from muscle. Your protocol has to cover that gap.']);
      if (F.id !== 'glp1' && a.hunger != null && a.hunger <= 2) d.push(['hunger', 'Dysregulated hunger', 'Constant or evening hunger tracks blood-sugar swings and low muscle mass - muscle is where carbs get stored. More muscle, steadier hunger.']);
      if (a.rebound === 0 || a.rebound === 1) d.push(['yoyo', 'Yo-yo dieting history', 'Every diet that burns muscle lowers your calorie burn - making the next rebound bigger. Protecting muscle breaks the cycle.']);
      if (a.plateau === 0) d.push(['plateau', 'Weight-loss plateau', 'Plateaus usually mean lost muscle has lowered your daily burn. Rebuilding it is how the scale starts moving again.']);
      if (picked('habits').length) d.push(['cravings', 'Evening cravings & stress eating', 'Cravings spike when cellular energy dips late in the day - steadier muscle energy means fewer 9pm kitchen raids.']);
      if (a.alcohol >= 2) d.push(['alcohol', 'Frequent alcohol', 'Alcohol blocks muscle recovery and adds empty calories - a double hit to your metabolism.']);
      if (a.water === 0) d.push(['water', 'Low water intake', 'Creatine works by hydrating muscle cells; chronic low water keeps stores and calorie burn down.']);
      if (a.diet === 3) d.push(['plant', 'Plant-based diet', 'You get almost no creatine from food. Vegetarians and vegans carry 20-30% lower muscle creatine stores and respond strongest to supplementation.']);
      else if (a.diet === 2 || a.diet === 1) d.push(['lowdiet', 'Low dietary creatine', 'Occasional meat or fish means your stores are rarely topped up from food.']);
      if (a.train === 0 || a.train === 1 || a.exercise === 2) d.push(['strength', 'Low strength stimulus', 'Muscle creatine is used and rebuilt through resistance work - with little of it, stores stay low and tone slips.']);
      if (a.sleep === 0 || a.sleep === 1) d.push(['sleep', 'Short sleep', 'Under 7 hours raises cortisol and drains the cellular energy (ATP) that creatine recycles.']);
      if (F.id === 'glp1') d.push(['glp', 'GLP-1 medication', 'Reduced appetite means less protein and creatine coming in, while rapid weight loss pulls from lean mass.']);
      if (a.protein === 0 || a.protein === 1) d.push(['protein', 'Very low protein intake', 'Without enough protein, the body breaks down muscle for fuel - creatine helps preserve it, but protein still matters.']);
      if (a.age >= 3 || (F.id === 'men' && a.age >= 1)) d.push(['age', 'Age-related decline', 'Natural creatine synthesis and muscle mass fall every decade after 30.']);
      if (has('medlist', 0)) d.push(['glplist', 'GLP-1 in your medication list', 'We’ll set your protocol to protect lean mass during weight loss.']);
      if (has('symptoms', 1) || a.energy === 0 || a.energy === 1) d.push(['crash', 'Afternoon energy crash', 'A classic sign of depleted phosphocreatine - the brain’s fast energy reserve.']);
      if (has('symptoms', 0) || has('mood', 3)) d.push(['fog', 'Brain fog', 'Brain cells use creatine for energy just like muscle; low stores show up as fog and forgetfulness.']);
      if (F.id === 'glp1') d.sort(function (x, y) { var o = { glp: 0, protein: 1 }; return (o[x[0]] != null ? o[x[0]] : 9) - (o[y[0]] != null ? o[y[0]] : 9); });
      if (!d.length) d.push(['ok', 'Mostly on track', 'Your habits are solid - the gap is dietary creatine, which is hard to get enough of from food alone.']);
      return d.slice(0, 4);
    }

    function sex() { return F.id === 'men' || answers.gender === 'male' ? 'male' : 'female'; }
    function bmi() {
      var h = ((answers.height && answers.height.cm) || 170) / 100;
      var w = (answers.weight && answers.weight.current) || 70;
      return w / (h * h);
    }
    function goalDate() {
      var R = results;
      var weeks = R.delta > 0 ? Math.max(4, Math.ceil(R.delta / 0.7)) : R.weeks;
      var d = new Date(Date.now() + weeks * 7 * 864e5);
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }

    /* ---------- shared fragments ---------- */
    function header(kind) {
      var logo = '<img class="bq-logo" src="' + esc(A.logo) + '" alt="OMNI" width="140" height="48">';
      if (kind === 'landing') return '<div class="bq-top">' + logo + '</div>';
      var backBtn = '<button type="button" class="bq-back" data-bq-back aria-label="Back">' + ICON.back + '<span>Back</span></button>';
      if (kind === 'post') {
        return '<div class="bq-top bq-top--post">' + logo + '<div class="bq-nav">' + backBtn + '<div class="bq-line"></div></div></div>';
      }
      var list = visible().filter(function (s) { return COUNTED[s.type]; });
      var cs = current();
      var n = list.indexOf(cs) + 1;
      var total = list.length;
      var pct = Math.max(3, Math.round(n / total * 100));
      return '<div class="bq-top">' + logo + '<div class="bq-nav">' + backBtn +
        '<div class="bq-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></div>' +
        '<div class="bq-count">' + n + ' of ' + total + '</div></div></div>';
    }

    function btn(text, attrs, white) {
      return '<button type="button" class="bq-btn' + (white ? ' bq-btn--white' : '') + '" ' + (attrs || '') + '>' + esc(text) + ICON.next + '</button>';
    }
    function head(title, sub) {
      return '<div class="bq-head"><h1 class="bq-h1">' + esc(title) + '</h1>' + (sub ? '<p class="bq-sub">' + esc(sub) + '</p>' : '') + '</div>';
    }
    function whyBox(t) { return t ? '<div class="bq-why"><b>Why we ask</b><p>' + esc(t) + '</p></div>' : ''; }
    function postHead(pill, titleHtml, lead) {
      return '<div class="bq-post-head"><div class="bq-post-title"><span class="bq-pill">' + esc(pill) + '</span><h1 class="bq-h1">' + titleHtml + '</h1></div>' +
        (lead ? '<p class="bq-sub">' + lead + '</p>' : '') + '</div>';
    }
    function checkList(items, cls) {
      return '<ul class="bq-checks' + (cls ? ' ' + cls : '') + '">' + items.map(function (t) {
        return '<li><img src="' + esc(icon('check')) + '" alt="" width="24" height="24"><span>' + esc(t) + '</span></li>';
      }).join('') + '</ul>';
    }

    /* ---------- screens ---------- */
    function vLanding() {
      var L = F.landing;
      return '<div class="bq-landing bq-fade">' + header('landing') +
        '<div class="bq-hero bq-glass' + (L.bullets ? ' bq-hero--bullets' : '') + (L.textLeft ? ' bq-hero--left' : '') + (L.tallMobileImage ? ' bq-hero--tallimg' : '') + '">' +
          '<div class="bq-hero-main">' +
            '<div class="bq-hero-copy"><div class="bq-hero-text"><h1 class="bq-h1">' + esc(L.title).replace(/\n/g, '<br>') + '</h1><p class="bq-sub">' + esc(L.lead).replace(/\n/g, ' <br class="bq-desk-br">') + '</p></div>' +
              (L.bullets ? checkList(L.bullets, 'bq-hero-bullets' + (L.bulletsTight ? ' bq-hero-bullets--tight' : '')) : '') + '</div>' +
            '<div class="bq-fr-box"><div class="bq-fr-slot" data-bq-fr-slot></div>' + vFrontrowMobile() + '</div>' +
            '<div class="bq-gender' + (L.ages ? ' bq-gender--ages' : '') + '"><p class="bq-gender-q">' + L.question + '</p><div class="bq-gender-btns">' +
              (L.ages ? L.ages.map(function (t, i) {
                return '<button type="button" class="bq-gbtn bq-gbtn--white" data-bq-age="' + i + '">' + esc(t) + '</button>';
              }) : (L.genders || [['female', 'red'], ['male', 'green']]).map(function (g) {
                return '<button type="button" class="bq-gbtn bq-gbtn--' + g[1] + '" data-bq-gender="' + g[0] + '">' + (g[0] === 'female' ? 'Female' : 'Male') + '</button>';
              })).join('') + '</div></div>' +
            '<div class="bq-press"><p>Creatine benefits are covered in</p><div class="bq-press-list' + (L.press ? ' bq-press-list--center' : '') + '">' + (L.press || ['Healthline', 'Men\u2019s Health', 'Women\u2019s Health', 'Forbes']).map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</div></div>' +
          '</div>' +
          '<div class="bq-hero-img"><picture>' + (L.heroImageMobile ? '<source media="(max-width: 749px)" srcset="' + esc(img(L.heroImageMobile)) + '">' : '') +
            '<img src="' + esc(img(L.heroImage)) + '" alt="OMNI Creatine Monohydrate Gummies" loading="eager"></picture></div>' +
        '</div></div>';
    }

    /* Clinicians' Choice: the theme's frontrow-banner widget is rendered once by Liquid into a
       hidden holder and moved into the landing slot (Figma position), parked again when leaving. */
    var frHolder = root.querySelector('[data-bq-frontrow]');
    function parkFrontrow() {
      if (!frHolder) return;
      var slot = app.querySelector('[data-bq-fr-slot]');
      if (!slot) return;
      Array.prototype.slice.call(slot.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && n.tagName !== 'IMG') frHolder.appendChild(n);
      });
    }
    function mountFrontrow() {
      if (!frHolder) return;
      var slot = app.querySelector('[data-bq-fr-slot]');
      if (!slot) return;
      Array.prototype.slice.call(frHolder.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && n.tagName !== 'SCRIPT') slot.insertBefore(n, slot.firstChild);
      });
      fillFrontrowMobile();
    }

    /* Clinicians' Choice numbers and photos, set by hand (F.frontrow in the funnel config overrides) */
    var FR_DEFAULT = {
      count: '675',
      photos: [
        'https://assets.app.thefrontrowhealth.com/yulyi33mil8glzv4b7fhzs5ipnz2',
        'https://assets.app.thefrontrowhealth.com/rdpnv5i5g5jmw9nl1c2udq4l2szf',
        'https://assets.app.thefrontrowhealth.com/pa8nliuewz7t7g0dmxjawwf0kr5a'
      ]
    };
    function frInfo() {
      var o = F.frontrow || {};
      return { count: String(o.count || FR_DEFAULT.count), photos: (o.photos && o.photos.length ? o.photos : FR_DEFAULT.photos).slice(0, 3) };
    }

    /* The Clinicians' Choice card (Figma 2776:26741 / 2776:26799) is drawn here; FrontrowMD's iframe
       stays in the page hidden only so its script can open the clinician modal on click. */
    var LAUREL = '<svg viewBox="0 0 19.56 40.28" aria-hidden="true"><path fill="#fff" d="M2.99591 11.6016C3.02609 14.6495 5.83078 17.0881 5.83078 17.0881C5.83078 17.0881 8.58779 14.5853 8.55944 11.5372C8.52875 8.48566 5.7225 6.0491 5.7225 6.0491C5.7225 6.0491 2.96756 8.55345 2.99591 11.6016ZM1.54819 22.0638C3.2091 24.6241 6.89457 25.2028 6.89457 25.2028C6.89457 25.2028 7.88795 21.63 6.22704 19.0697C4.56612 16.5093 0.878553 15.9291 0.878553 15.9291C0.878553 15.9291 -0.114559 19.5037 1.54819 22.0638ZM4.40527 31.486C7.09409 32.9538 10.6191 31.7261 10.6191 31.7261C10.6191 31.7261 9.78287 28.1167 7.09406 26.6488C4.40523 25.181 0.880182 26.4087 0.880182 26.4087C0.880182 26.4087 1.71645 30.018 4.40527 31.486ZM12.1222 38.3905C15.0599 39.2751 18.2555 37.352 18.2555 37.352C18.2555 37.352 16.6863 33.9943 13.7483 33.1079C10.8105 32.2233 7.6171 34.148 7.6171 34.148C7.6171 34.148 9.18448 37.5059 12.1222 38.3905ZM10.3779 3.79255C8.45 6.1695 9.0495 9.82329 9.0495 9.82329C9.0495 9.82329 12.7792 9.62626 14.7071 7.2493C16.635 4.87234 16.0352 1.21674 16.0352 1.21674C16.0352 1.21674 12.3057 1.41559 10.3779 3.79255Z"/></svg>';
    function vFrontrowMobile() {
      return '<button type="button" class="bq-fr-mob" data-bq-fr-open aria-label="Clinicians\u2019 Choice: view clinicians on FrontrowMD">' +
        '<span class="bq-fr-badge">' + LAUREL + '<span>Clinicians\'<br>Choice</span>' + LAUREL.replace('<svg ', '<svg class="bq-fr-flip" ') + '</span>' +
        '<span class="bq-fr-copy"><span class="bq-fr-text"><b><span data-bq-fr-count>' + esc(frInfo().count) + '</span> clinicians</b> share this on <span class="bq-fr-l2">FrontrowMD without compensation.</span></span>' +
        '<span class="bq-fr-row"><span class="bq-fr-faces" data-bq-fr-faces></span><u>View clinicians &amp; learn more</u></span></span></button>';
    }
    function fillFrontrowMobile() {
      var card = app.querySelector('[data-bq-fr-open]');
      if (!card) return;
      if (!card.__bqBound) {
        card.__bqBound = true;
        /* FrontrowMD's script (loaded with the widget) opens its clinician modal on this message */
        card.addEventListener('click', function () { window.postMessage('OPEN_MODAL_STICKER', '*'); });
      }
      var d = frInfo();
      card.querySelector('[data-bq-fr-count]').textContent = d.count;
      card.querySelector('[data-bq-fr-faces]').innerHTML = d.photos.map(function (url) {
        return '<img src="' + esc(url) + '" alt="" width="24" height="24">';
      }).join('');
    }

    /* per-step layout flags from the funnel config: wide = 1280px head/answers, h1 = 40 → smaller
       desktop title (the Figma frames mix 48px and 40px titles), yn = the two yes/no pills are a fixed 200px */
    function qcls(s) { return (s.wide ? ' bq-q--wide' : '') + (s.h1 === 40 ? ' bq-q--h40' : '') + (s.yn ? ' bq-q--yn' : ''); }

    function vSingle(s) {
      var v = answers[s.id];
      return '<div class="bq-q' + qcls(s) + '">' + head(s.title, s.sub) +
        '<div class="bq-opts bq-opts--single" role="radiogroup">' + s.opts.map(function (o, i) {
          return '<button type="button" class="bq-opt' + (v === i ? ' is-selected' : '') + '" role="radio" aria-checked="' + (v === i) + '" data-bq-opt="' + i + '"><span class="bq-opt-label">' + esc(o) + '</span></button>';
        }).join('') + '</div>' + whyBox(s.why) + '</div>';
    }

    function vMulti(s) {
      var v = Array.isArray(answers[s.id]) ? answers[s.id] : [];
      return '<div class="bq-q' + qcls(s) + '">' + head(s.title, s.sub) +
        '<div class="bq-opts" role="group">' + s.opts.map(function (o, i) {
          var on = v.indexOf(i) !== -1;
          return '<button type="button" class="bq-opt' + (on ? ' is-selected' : '') + '" role="checkbox" aria-checked="' + on + '" data-bq-opt="' + i + '"><span class="bq-opt-label">' + esc(o) + '</span><span class="bq-check">' + ICON.tick + '</span></button>';
        }).join('') + '</div>' + whyBox(s.why) + '</div>' +
        '<div class="bq-footer">' + btn('Next', 'data-bq-next' + (v.length ? '' : ' disabled')) + '</div>';
    }

    function vBodymap(s) {
      var sx = sex();
      var v = Array.isArray(answers[s.id]) ? answers[s.id] : [];
      return '<div class="bq-q">' + head(s.title, s.sub) +
        '<div class="bq-bm" data-sex="' + sx + '"><div class="bq-bm-fig">' + (BODY[sx] || '') + '</div>' +
        AREAS[sx].map(function (t) {
          var on = v.indexOf(t.key) !== -1;
          return '<button type="button" class="bq-bm-tag' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-bq-area="' + t.key + '" style="--x:' + t.x + 'px;--y:' + t.y + 'px;--mx:' + t.mx + 'px;--my:' + t.my + 'px">' + esc(t.label) + '</button>';
        }).join('') + '</div></div>' +
        '<div class="bq-footer">' + btn('Next', 'data-bq-next' + (v.length ? '' : ' disabled')) + '</div>';
    }

    function paintBody() {
      var v = answers.areas || [];
      var whole = v.indexOf('whole') !== -1;
      app.querySelectorAll('.bq-bm-part').forEach(function (p) {
        p.classList.toggle('is-on', whole || v.indexOf(p.getAttribute('data-area')) !== -1);
      });
    }

    function vInfo(s) {
      return '<div class="bq-info bq-glass">' +
        '<div class="bq-info-head"><h1>' + esc(s.title) + '</h1><p>' + esc(s.lead) + '</p></div>' +
        '<div class="bq-info-img"><img src="' + esc(img(s.image)) + '" alt="OMNI Creatine Monohydrate Gummies" loading="lazy"></div>' +
        '<div class="bq-info-box"><p class="bq-info-intro' + (s.introLeft ? ' bq-info-intro--left' : '') + '" data-desk="' + esc(s.intro) + '" data-mob="' + esc(s.introMobile || s.intro) + '">' + esc(s.intro) + '</p>' +
        checkList(s.bullets) + (s.close ? '<p class="bq-info-close">' + esc(s.close) + '</p>' : '') +
        (s.fine ? '<p class="bq-info-fine">' + esc(s.fine) + '</p>' : '') + '</div></div>' +
        '<div class="bq-footer">' + btn('Next', 'data-bq-next') + '</div>';
    }

    function unitToggle() {
      return '<div class="bq-units" role="tablist"><button type="button" role="tab" class="' + (units === 'imperial' ? 'is-on' : '') + '" data-bq-units="imperial">Imperial</button>' +
        '<button type="button" role="tab" class="' + (units === 'metric' ? 'is-on' : '') + '" data-bq-units="metric">Metric</button></div>';
    }
    function field(id, ph, unit, val, mode) {
      var len = { ft: 1, in: 2 }[id] || 3;
      return '<label class="bq-field' + (val !== '' ? ' is-filled' : '') + '"><input id="bq-' + id + '" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="' + len + '" data-len="' + len + '" placeholder="' + esc(ph) + '" value="' + esc(val) + '" autocomplete="off"><span>' + esc(unit) + '</span></label>';
    }

    function vHeight(s) {
      var cm = answers.height && answers.height.cm;
      var fields = units === 'imperial'
        ? field('ft', 'Feet', 'ft', cm ? Math.floor(Math.round(cm / 2.54) / 12) : '') + field('in', 'Inches', 'in', cm ? Math.round(cm / 2.54) % 12 : '')
        : field('cm', 'Height', 'cm', cm || '');
      return '<div class="bq-measure"><div class="bq-measure-top"><h1 class="bq-h1">' + esc(s.title) + '</h1>' + unitToggle() + '</div>' +
        '<div class="bq-fields">' + fields + '</div><div class="bq-error" data-bq-error hidden></div></div>' +
        '<div class="bq-footer bq-footer--bottom">' + btn('Next', 'data-bq-submit' + (cm ? '' : ' disabled')) + '</div>';
    }

    function vWeight(s) {
      var w = answers.weight || {};
      var f = units === 'imperial' ? 2.2046 : 1;
      var u = units === 'imperial' ? 'lbs' : 'kg';
      return '<div class="bq-measure"><div class="bq-measure-top"><h1 class="bq-h1 bq-h1--narrow">' + esc(s.title) + '</h1>' + unitToggle() + '</div>' +
        '<p class="bq-field-label">Current weight</p><div class="bq-fields">' + field('cw', 'Weight', u, w.current ? Math.round(w.current * f) : '', 'decimal') + '</div>' +
        '<p class="bq-field-label">Goal weight</p><div class="bq-fields">' + field('gw', 'Weight', u, w.goal ? Math.round(w.goal * f) : '', 'decimal') + '</div>' +
        '<div class="bq-error" data-bq-error hidden></div>' +
        '<div class="bq-footer">' + btn('Next', 'data-bq-submit' + (w.current ? '' : ' disabled')) + '<p class="bq-note">' + esc(s.note) + '</p></div></div>';
    }

    function vLoader(s) {
      var r = 94, c = (2 * Math.PI * r).toFixed(2);
      return '<div class="bq-loader"><div class="bq-ring"><svg viewBox="0 0 200 200" aria-hidden="true"><defs><linearGradient id="bqRingGrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#96B4D4"/><stop offset="100%" stop-color="#33517D"/></linearGradient></defs>' +
        '<circle class="bq-ring-disc" cx="100" cy="100" r="76"/><circle class="bq-ring-track" cx="100" cy="100" r="' + r + '"/>' +
        '<circle class="bq-ring-fg" cx="100" cy="100" r="' + r + '" stroke-dasharray="' + c + '" stroke-dashoffset="' + c + '" data-bq-ring/></svg>' +
        '<div class="bq-ring-center"><span class="bq-ring-value"><span data-bq-pct>0</span><small>%</small></span><span class="bq-ring-label">analyzes</span></div></div>' +
        '<h1 class="bq-h1">' + esc(s.title) + '</h1>' +
        '<ul class="bq-steps">' + s.checks.map(function (t) { return '<li><span></span>' + esc(t) + '</li>'; }).join('') + '</ul></div>';
    }

    function runLoader(s) {
      var ring = app.querySelector('[data-bq-ring]');
      var pct = app.querySelector('[data-bq-pct]');
      var rows = app.querySelectorAll('.bq-steps li');
      var c = 2 * Math.PI * 94, dur = 4200, t0 = Date.now();
      var tick = function () {
        var p = Math.min(1, (Date.now() - t0) / dur);
        ring.style.strokeDashoffset = (c * (1 - p)).toFixed(2);
        pct.textContent = Math.round(p * 100);
        var active = Math.min(rows.length - 1, Math.floor(p * rows.length));
        rows.forEach(function (li, i) {
          var state = p >= 1 || i < active ? 'done' : i === active ? 'active' : 'todo';
          if (li.getAttribute('data-state') === state) return;
          li.setAttribute('data-state', state);
          li.className = state === 'todo' ? '' : 'is-' + state;
          li.firstChild.innerHTML = state === 'done' ? '<img src="' + esc(icon('check')) + '" alt="">' : ICON.spin;
        });
        if (p < 1) { loaderTimer = setTimeout(tick, 40); return; }
        computeResults();
        track('quiz_completed', { tier: results.tier, score: results.score });
        loaderTimer = setTimeout(function () {
          step += 1;
          try { history.replaceState({ bq: step }, ''); } catch (e) {}
          render();
        }, 350);
      };
      tick();
    }

    function vEmail(s) {
      return '<div class="bq-email"><div class="bq-email-head"><span class="bq-pill">' + esc(s.label) + '</span>' +
        '<h1 class="bq-h1">' + esc(s.title) + '</h1><p class="bq-sub">' + s.text + '</p></div>' +
        '<form class="bq-email-form" data-bq-email novalidate><label class="bq-field"><input type="email" name="email" placeholder="Your email address" autocomplete="email" required value="' + esc(answers.email || '') + '"></label>' +
        '<button type="submit" class="bq-btn bq-btn--white">Unlock my protocol' + ICON.next + '</button>' +
        '<p class="bq-email-legal">By entering your email address, you agree and accept our <a href="' + esc(A.privacyUrl || '/pages/privacy-policy') + '" target="_blank" rel="noopener">Privacy Policy</a></p></form></div>';
    }

    /* ---------- R1-R7 ---------- */
    function vPost(s) {
      var R = results, a = liveAnswers(), n = +s.id.slice(1);
      var cont = function (t) { return '<div class="bq-footer">' + btn(t || 'Continue', 'data-bq-next', true) + '</div>'; };

      if (n === 1) {
        var b = bmi(), cat = b < 18.5 ? 'Underweight' : b < 25 ? 'Normal' : b < 30 ? 'Overweight' : 'Obese';
        var status = R.tier === 'high' ? ['Depleted', 'is-red'] : R.tier === 'medium' ? ['Below optimal', 'is-amber'] : ['Adequate', 'is-green'];
        var rows = [
          ['Creatine status', status[0], status[1]],
          ['BMI', b.toFixed(1) + ' · ' + cat, b < 25 ? 'is-green' : 'is-amber'],
          ['Main goal', label('goals', (a.goals || [])[0]) || F.results.goalFallback || 'More energy'],
          F.results.profileRow ? F.results.profileRow(a, label) :
            ['Dietary creatine', label('diet', a.diet) ? label('diet', a.diet).replace(' (plant-based)', '') : 'Unknown'],
          ['Strength training', label('train', a.train) || label('exercise', a.exercise) || '-'],
          ['Age', label('age', a.age) || '-']
        ];
        if (F.results.profileTweak) rows = F.results.profileTweak(rows, a, label);
        if (picked('hormones').length) rows.splice(3, 0, ['Hormonal factors', picked('hormones').slice(0, 2).map(function (i) { return stepById('hormones').opts[i]; }).join(', '), 'is-amber']);
        if (a.childhood === 0 || a.childhood === 1) rows.splice(3, 0, ['Weight history', a.childhood === 0 ? 'Since childhood' : 'Up and down for years', 'is-amber']);
        if (picked('lowt').length) rows.splice(3, 0, ['Low-T signs', picked('lowt').length + ' reported', 'is-amber']);
        var answered = Object.keys(a).filter(function (k) { return k !== 'email' && k !== 'gender'; }).length;
        var knob = R.tier === 'high' ? 18 : R.tier === 'medium' ? 45 : 72;
        return '<div class="bq-post bq-post--r1">' + postHead('Your creatine profile', 'Here’s what your answers tell us', 'Based on ' + answered + ' answers we built a picture of where your energy and muscle stand today.') +
          '<div class="bq-list"><div class="bq-card bq-glass"><div class="bq-gauge"><div class="bq-gauge-bar"></div><span class="bq-gauge-knob" style="left:' + knob + '%"></span>' +
          '<div class="bq-gauge-labels"><span>Depleted</span><span>Low</span><span>Normal</span><span>Optimal</span></div></div>' +
          '<div class="bq-kv">' + rows.map(function (r) { return '<div><span>' + esc(r[0]) + '</span><b class="' + (r[2] || '') + '">' + esc(r[1]) + '</b></div>'; }).join('') + '</div></div>' +
          '<p class="bq-fine">Estimates based on self-reported answers, not a clinical measurement.</p></div>' + cont() + '</div>';
      }

      if (n === 2) {
        var d = drivers();
        var what = F.results.driversWhat || 'making your body composition worse';
        var ttl = d.length > 1 ? d.length + ' things are ' + what : 'One thing is ' + what;
        return '<div class="bq-post bq-post--r2">' + postHead('Why', esc(ttl), 'These came straight from your answers - and each one is something the protocol is built to fix.') +
          '<div class="bq-list">' + d.map(function (x) {
            var big = x[0] === 'lowdiet' || x[0] === 'crash' || x[0] === 'age' || x[0] === 'plateau';
            return '<div class="bq-row"><span class="bq-row-icon' + (big ? '' : ' bq-row-icon--48') + '"><img src="' + esc(icon(DRIVER_ICON[x[0]] || 'battery')) + '" alt=""></span><div class="bq-row-text"><b>' + esc(x[1]) + '</b><p>' + esc(x[2]) + '</p></div></div>';
          }).join('') + '</div>' + cont() + '</div>';
      }

      if (n === 3) {
        var date = goalDate();
        var title = R.delta > 0 ? 'You could reach ' + esc(R.fmt(R.goalW)) + ' by <span class="bq-green-text">' + esc(date) + '</span>' : 'Full creatine saturation by <span class="bq-green-text">' + esc(date) + '</span>';
        var lead = R.delta > 0 ? 'That’s ' + esc(R.fmt(R.delta)) + ' at a sustainable 0.5-1 kg per week, with creatine keeping the loss on fat rather than muscle.' : 'Muscle stores saturate in 3-4 weeks of daily use; strength and energy changes follow.';
        var miles = [
          ['Week 1-2', 'Loading Phase', 'Muscle cells fill with creatine. Most people notice steadier energy first.'],
          ['Week 3-4', 'Activation Phase', 'Strength up 5-10%, recovery faster, afternoon crash fades.'],
          ['Week ' + (R.weeks > 4 ? '5-' + R.weeks : '4+'), 'Optimization Phase', 'Visible tone changes; body composition shifts with training.', R.weeks >= 12 ? 'Month 2-3' : R.weeks > 4 ? 'Month 2' : '']
        ];
        return '<div class="bq-post bq-post--630 bq-post--r3">' + postHead('Your projection', title, lead) +
          '<div class="bq-list bq-r3-body">' + chart() +
          '<div class="bq-miles">' + miles.map(function (m) {
            return '<div class="bq-mile"><div class="bq-mile-rail">' + ICON.dot + '<i></i></div><div class="bq-mile-text"><div class="bq-mile-top"><span>' + (m[3] ? '<span class="bq-desk-only">' + esc(m[0]) + '</span><span class="bq-mob-only">' + esc(m[3]) + '</span>' : esc(m[0])) + '</span><b>' + esc(m[1]) + '</b></div><p>' + esc(m[2]) + '</p></div></div>';
          }).join('') + '</div></div>' + cont() + '</div>';
      }

      if (n === 4) {
        var sel = (a.areas || []).slice();
        if (!sel.length) sel = ['whole'];
        var names = AREAS[sex()].reduce(function (m, t) { m[t.key] = t.label; return m; }, {});
        var tag = sex() === 'male' ? 'm' : 'f';
        var list = sel.map(function (k) { return names[k] || k; });
        var ttl4 = 'What creatine does for <span class="bq-r4-tail">your <span class="bq-green-text">' + esc(list.join(', ').toLowerCase()) + '</span></span>';
        return '<div class="bq-post bq-post--r4">' + postHead('Your body map', ttl4, 'You tapped ' + sel.length + ' area' + (sel.length === 1 ? '' : 's') + '. Here’s the honest version of what to expect in each.') +
          '<div class="bq-list">' + sel.map(function (k) {
            var thumb = img('area_' + tag + '_' + ({ chest: 'whole', love: 'arms' }[k] || k));
            return '<div class="bq-row"><span class="bq-row-thumb"><img src="' + esc(thumb) + '" alt="" loading="lazy"></span><div class="bq-row-text"><b>' + esc(names[k] || k) + '</b><p>' + esc(AREA_COPY[k] || '') + '</p></div></div>';
          }).join('') + '</div>' + cont() + '</div>';
      }

      if (n === 5) {
        var tried = picked('tried').map(function (i) { return stepById('tried').opts[i]; });
        var rows5 = tried.map(function (t) { return TRIED_COPY[t]; }).filter(Boolean).slice(0, 3);
        var fresh = !rows5.length;
        if (fresh) rows5 = [['protein', 'Protein alone', 'Protein is the bricks; creatine is the energy to lay them. Without both, muscle still slips.'], ['dieting', 'Eating less', 'A calorie deficit pulls from lean mass unless something signals the body to keep it.']];
        var cmp = [['Daily Dose', '3g, 1-3 gummies', '5g scoop + shaker'], ['Bloating', 'None reported', 'Common'], ['Taste', 'Watermelon / Peach', 'Chalky'], ['Sticks past 30 days', '81% of subscribers', '~35%']];
        var grid = '<div class="bq-compare"><div class="bq-compare-bg bq-glass"></div>' +
          '<div class="bq-cc" style="grid-column:1;grid-row:1"></div>' +
          '<div class="bq-cc bq-cc-head" style="grid-column:2;grid-row:1"><img src="' + esc(img('omniThumb')) + '" alt="OMNI gummies"><span>omni</span></div>' +
          '<div class="bq-cc bq-cc-head bq-cc-head--muted" style="grid-column:3;grid-row:1"><div class="bq-cc-tile"><img src="' + esc(img('powder')) + '" alt="Creatine powder"></div><span>Powder</span></div>' +
          cmp.map(function (r, i) {
            var last = i === cmp.length - 1 ? ' is-last' : '';
            var row = 'grid-row:' + (i + 2);
            return '<div class="bq-cc bq-cc-cell bq-cc-cell--label' + last + '" style="grid-column:1;' + row + '">' + esc(r[0]) + '</div>' +
              '<div class="bq-cc bq-cc-cell bq-cc-cell--omni' + last + '" style="grid-column:2;' + row + '"><img src="' + esc(icon('checkBroken')) + '" alt=""><span>' + esc(r[1]) + '</span></div>' +
              '<div class="bq-cc bq-cc-cell bq-cc-cell--powder' + last + '" style="grid-column:3;' + row + '"><img src="' + esc(icon('x')) + '" alt=""><span>' + esc(r[2]) + '</span></div>';
          }).join('') + '</div>';
        return '<div class="bq-post bq-post--700 bq-post--r5"><div class="bq-list bq-r5-top">' +
          postHead('What you’ve tried', fresh ? (F.results.triedFallbackTitle || 'Why diet and protein alone won’t do it') : 'Why ' + (rows5.length > 1 ? 'those didn’t' : 'that didn’t') + ' stick - and why this will', 'Most fixes work on the symptom. Creatine works on the cell’s energy supply itself.') +
          '<div class="bq-list">' + rows5.map(function (x) {
            return '<div class="bq-row"><span class="bq-row-icon bq-row-icon--48"><img src="' + esc(icon(x[0])) + '" alt=""></span><div class="bq-row-text"><b>' + esc(x[1]) + '</b><p>' + esc(x[2]) + '</p></div></div>';
          }).join('') + '</div></div>' + grid + '<div class="bq-footer" style="margin-top:0">' + btn('Continue', 'data-bq-next', true) + '</div></div>';
      }

      if (n === 6) {
        return '<div class="bq-post bq-post--800 bq-post--r6">' + postHead('People like you', '<span class="bq-green-text">' + esc(F.results.audience) + '</span> with your profile run their day on OMNI', esc(F.results.matchedTo)) +
          '<div class="bq-reviews">' + F.results.reviews.map(function (r) {
            return '<div class="bq-review"><p>“' + esc(r[1]) + '”</p><div class="bq-who"><i>' + esc(r[0].charAt(0)) + '</i><b>' + esc(r[0]) + '</b><span><img src="' + esc(icon('verified')) + '" alt="">' + esc(r[2] || 'Verified buyer') + '</span></div></div>';
          }).join('') + '</div>' +
          '<div class="bq-rating"><span class="bq-stars">' + new Array(6).join('<img src="' + esc(icon('star')) + '" alt="">') + '</span><b>4.8</b><span>2,300+ verified reviews</span></div>' + cont() + '</div>';
      }

      /* n === 7 */
      var why7 = R.glp ? 'Set for muscle protection during GLP-1 weight loss.' : R.plant ? 'Extended to 12 weeks because plant-based stores start lower.' : R.tier === 'high' ? 'Extended to 12 weeks because your stores read as depleted.' : 'Enough to fully saturate your stores and lock in the habit.';
      var packs = R.plan === 'p3' ? 3 : R.plan === 'p2' ? 2 : 1;
      var tips = [
        'Take with any meal - no loading phase needed',
        a.train === 0 || a.exercise === 2 ? 'Add 2 short (15 minutes) strength sessions a week to unlock the full effect' : 'Keep your current training - creatine will lift your output',
        R.glp ? 'Hit 1.2g protein per kg of goal weight' : 'Drink a little more water the first two weeks',
        'Free ' + F.results.guide + ' guide included with your order'
      ];
      return '<div class="bq-post bq-post--630 bq-post--r7">' + postHead('Your protocol is ready', R.dose + '× gummy serving a day for <span class="bq-green-text">' + R.weeks + ' weeks</span>', esc(why7)) +
        '<div class="bq-list" style="gap:24px"><div class="bq-stats-card bq-glass"><b>Your creatine protocol</b><div class="bq-stats">' +
        '<div class="bq-stat"><b>' + (R.dose * STORE.servingGrams) + 'g</b><span>creatine / day</span></div>' +
        '<div class="bq-stat"><b>' + R.weeks + '</b><span>weeks</span></div>' +
        '<div class="bq-stat"><b>' + packs + '</b><span>pack' + (packs > 1 ? 's' : '') + ' recommended</span></div></div></div>' +
        '<div class="bq-box">' + checkList(tips, 'bq-checks--loose') + '</div>' +
        '<p class="bq-left-note">Your discount code is waiting on the next page.</p></div>' + cont('See my plan') + '</div>';
    }

    function chart() {
      var R = results;
      return '<div class="bq-chart-card bq-glass"><p class="bq-chart-title">' + esc(F.results.chartTitle) + '</p>' +
        '<div class="bq-chart"><svg class="bq-chart-plot" viewBox="0 0 566 236" preserveAspectRatio="none" aria-hidden="true">' +
          '<defs><linearGradient id="bqArea" x1="265" y1="96" x2="290" y2="231" gradientUnits="userSpaceOnUse"><stop stop-color="#239627" stop-opacity=".2"/><stop offset="1" stop-color="#239627" stop-opacity="0"/></linearGradient></defs>' +
          '<g stroke="#6C93C2" stroke-opacity=".2" stroke-width="2"><line x1="0" y1="15" x2="566" y2="15"/><line x1="0" y1="125.5" x2="566" y2="125.5"/><line x1="0" y1="235" x2="566" y2="235"/></g>' +
          '<path d="M2.29 230L277.84 82.5L420.2 33.75L562.56 15V230H2.29Z" fill="url(#bqArea)"/>' +
          '<path d="M562.56 15L426.14 32.97C422.19 33.49 418.3 34.4 414.54 35.69L282.44 80.93C279.38 81.97 276.41 83.27 273.56 84.79L2.29 230" fill="none" stroke="#239627" stroke-width="6" stroke-linecap="round" vector-effect="non-scaling-stroke"/>' +
          '<path d="M560.26 213.5L480.34 214.25L407.92 206.78C402.95 206.26 397.92 206.37 392.98 207.11L308.58 219.6C304.52 220.2 300.4 220.38 296.29 220.14L208.52 215L2.28 230" fill="none" stroke="#D42929" stroke-width="6" stroke-linecap="round" vector-effect="non-scaling-stroke"/>' +
        '</svg>' +
        '<svg class="bq-chart-dot" style="left:0.88%;top:97.5%" viewBox="0 0 24 24"><rect width="24" height="24" rx="12" fill="#fff" fill-opacity=".2"/><circle cx="12" cy="12" r="6" fill="#F1F5F9"/></svg>' +
        '<svg class="bq-chart-dot" style="left:97.9%;top:6.4%" viewBox="0 0 24 24"><rect width="24" height="24" rx="12" fill="#239627"/><circle cx="12" cy="12" r="6" fill="#fff"/></svg>' +
        '<span class="bq-chart-tag bq-chart-tag--start">' + esc(R.fmt(R.current)) + '</span>' +
        '<span class="bq-chart-tag bq-chart-tag--end">' + esc(R.fmt(R.delta > 0 ? R.goalW : R.current)) + '</span></div>' +
        '<div class="bq-legend"><span><i style="background:#239627"></i>With OMNI</span><span><i style="background:#D42929"></i>Without</span></div></div>';
    }

    /* ---------- checkout ---------- */
    function packOf(p) {
      var c = STORE.cards[p], k = STORE.packs[c.pack];
      return { watermelon: k.watermelon, peach: k.peach, code: c.code || k.code, plan: c.plan, qty: c.qty || 1, pack: c.pack };
    }
    /* href only (no-JS / new-tab fallback). A cart permalink drops the selling plan, and the pack codes
       only apply to subscription lines, so the real click goes through orderNow below. */
    function cartLink(p) {
      var k = packOf(p);
      return STORE.url + '/cart/' + k[flavor] + ':' + k.qty + '?selling_plan=' + k.plan + '&discount=' + encodeURIComponent(k.code);
    }
    /* the quiz-pdp buy box flow (tested on the live store: 1x → "Deliver every 4 weeks", 1x-Pouch −$29,
       $38 at checkout): replace the cart with the subscription line, apply the pack's code, open checkout */
    /* loading state like the product page buy box (ButtonLoader): arrow → spinner, dimmed, not clickable */
    var SPINNER = '<svg class="bq-btn-spin" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" fill="none" opacity="0.3"/><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="15.708 31.416" fill="none"/></svg>';
    function btnLoading(a, on) {
      var icon = a.querySelector('svg');
      if (on) {
        a.__bqIcon = icon ? icon.outerHTML : '';
        if (icon) icon.outerHTML = SPINNER; else a.insertAdjacentHTML('beforeend', SPINNER);
        a.classList.add('is-loading');
        a.setAttribute('aria-disabled', 'true');
        a.setAttribute('aria-busy', 'true');
      } else {
        if (icon && a.__bqIcon) icon.outerHTML = a.__bqIcon;
        a.classList.remove('is-loading');
        a.removeAttribute('aria-disabled');
        a.removeAttribute('aria-busy');
      }
    }
    /* coming back from checkout with the browser's back button restores the page as it was left */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) app.querySelectorAll('[data-bq-order].is-loading').forEach(function (a) { btnLoading(a, false); });
    });
    function orderNow(p, a) {
      var k = packOf(p);
      if (a.getAttribute('aria-disabled') === 'true') return;
      btnLoading(a, true);
      var post = function (url, body) {
        return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
      };
      post('/cart/clear.js', {})
        .then(function () {
          return post('/cart/add.js', { items: [{ id: parseInt(k[flavor], 10), quantity: k.qty, selling_plan: parseInt(k.plan, 10), properties: { _landing_config: STORE.landingConfig } }] });
        })
        .then(function () {
          /* `discount` replaces any code already on the cart (a /discount/CODE visit only adds to it) */
          return post('/cart/update.js', { discount: k.code, attributes: { quiz: 'vol4-' + root.getAttribute('data-funnel'), quiz_plan: p } });
        })
        .then(function () {
          window.location.href = '/checkout?discount=' + encodeURIComponent(k.code);
        })
        .catch(function () {
          btnLoading(a, false);
          window.location.href = cartLink(p);
        });
    }

    function vCheckout() {
      var R = results, c = STORE.currency;
      var packs = R.plan === 'p3' ? 3 : R.plan === 'p2' ? 2 : 1;
      var plan = function (id) {
        var P = STORE.plans[id];
        var card = '<div class="bq-plan' + (P.best ? ' bq-plan--best' : '') + '"><div class="bq-plan-head"><div><b>' + esc(P.title) + '</b><p>' + esc(P.desc) + '</p></div>' + (P.gift ? '<span class="bq-gift">+Free gift</span>' : '') + '</div>' +
          '<div class="bq-price"><b>' + c + P.price + '</b><s>' + c + P.compare + '</s></div><hr>' +
          '<ul class="bq-checks">' + [P.servings + ' daily servings', c + P.perDay + ' per day', P.packs + ' pack' + (P.packs > 1 ? 's' : '') + ' delivered'].map(function (t) {
            return '<li>' + ICON.planCheck + '<span>' + esc(t) + '</span></li>';
          }).join('') + '</ul>' +
          '<div class="bq-plan-cta"><a class="bq-btn" href="' + esc(cartLink(id)) + '" data-bq-order="' + id + '">Order now' + ICON.next + '</a><p>Cancel anytime. Free shipping.</p></div></div>';
        return '<div class="bq-plan-wrap' + (P.banner ? '' : ' bq-plan-wrap--basic') + '">' +
          (P.banner ? '<div class="bq-plan-banner bq-plan-banner--' + P.bannerTone + '">' + esc(P.banner) + '</div>' : '') + card + '</div>';
      };
      var flavors = [['watermelon', 'Watermelon', img('watermelon')], ['peach', 'Peach', img('peach')]];
      return '<div class="bq-checkout">' +
        '<div class="bq-co-col">' +
          '<div class="bq-promo bq-glass"><b>Your personal protocol discount is applied!</b>' +
            '<div class="bq-promo-row"><span>Code</span><span class="bq-timer" data-bq-timer>15 : 00</span></div>' +
            '<div class="bq-code"><svg class="bq-code-rim" aria-hidden="true"><rect x="0" y="0" width="100%" height="100%" rx="18" ry="18"/></svg><span>' + esc(F.promo) + '</span>' + ICON.codeOk + '</div></div>' +
          '<div class="bq-co-title"><h1 class="bq-h1">Select your supply to <span class="bq-green-text">' + esc(R.goal) + '</span></h1><p class="bq-sub">Based on your answers · ' + esc(F.name) + '</p></div>' +
          '<div class="bq-stats-card bq-glass"><b>Your creatine protocol</b><div class="bq-stats">' +
            '<div class="bq-stat"><b>' + R.dose + '×</b><span>gummy serving / day (' + (R.dose * STORE.servingGrams) + 'g)</span></div>' +
            '<div class="bq-stat"><b>' + R.weeks + '<small> wks</small></b><span>recommended protocol</span></div>' +
            '<div class="bq-stat"><b>' + (R.tier === 'high' ? 'High' : R.tier === 'medium' ? 'Moderate' : 'Low') + esc(F.results.tierSuffix || '') + '</b><span>depletion risk</span></div></div></div>' +
          '<div class="bq-flavors" role="radiogroup">' + flavors.map(function (f) {
            return '<button type="button" class="bq-flavor' + (flavor === f[0] ? ' is-on' : '') + '" role="radio" aria-checked="' + (flavor === f[0]) + '" data-bq-flavor="' + f[0] + '"><img src="' + esc(f[2]) + '" alt=""><span>' + f[1] + '</span>' + (f[0] === 'peach' ? '<span class="bq-new">New</span>' : '') + '</button>';
          }).join('') + '</div>' +
        '</div>' +
        '<div class="bq-list" style="gap:24px"><div class="bq-plans">' + plan('p1') + plan('p2') + plan('p3') + '</div>' +
          '<p class="bq-fine">Plan renews based on the quantity selected until cancelled. Guaranteed safe checkout.</p></div>' +
        '<div class="bq-trust"><div><img src="' + esc(icon('guarantee')) + '" alt="">30-Day Guarantee</div><i></i><div><img src="' + esc(icon('package')) + '" alt="">Free US Shipping</div><i></i><div><img src="' + esc(img('usa')) + '" alt="">Made in the USA</div></div>' +
        '<div class="bq-co-col">' + chart() +
          '<div class="bq-reco"><b>Based on your data, we recommend</b>' + ['p3', 'p2', 'p1'].map(function (p) {
            return '<div class="bq-reco-item' + (R.plan === p ? ' is-on' : '') + '"><b>' + esc(STORE.reco[p][0]) + '</b><p>' + esc(STORE.reco[p][1]) + '</p></div>';
          }).join('') + '</div>' +
          '<div class="bq-bonus"><b>You will also <span class="bq-green-text">get FREE</span></b><div class="bq-bonus-grid">' +
            '<div class="bq-bonus-item"><div class="bq-bonus-art">📖</div><p>' + esc(F.results.bonusGuide || F.results.guide) + ' guide</p><span class="bq-bonus-tag">Free <s>$15.99</s></span></div>' +
            '<div class="bq-bonus-item"><div class="bq-bonus-art">💪</div><p>12-week strength plan</p><span class="bq-bonus-tag">Free <s>$33.99</s></span></div>' +
            '<div class="bq-bonus-item"><div class="bq-bonus-art">🎁</div><p>Mystery gift with your order</p><span class="bq-bonus-tag">Free</span></div></div></div>' +
          '<div class="bq-footer" style="margin-top:0"><a class="bq-btn bq-btn--white" href="' + esc(cartLink(R.plan)) + '" data-bq-order="' + R.plan + '">Get OMNI now' + ICON.next + '</a></div>' +
          '<p class="bq-disclaimer">© 2026 OMNI Creatine. Disclaimer: These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure, or prevent any disease. Exercise and a healthy diet are necessary to achieve and maintain results.</p>' +
        '</div></div>';
    }

    function startTimer() {
      var key = 'omni_quiz_v4_promo_' + F.id, end = 0;
      try { end = +localStorage.getItem(key) || 0; } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + STORE.promoMinutes * 60000;
        try { localStorage.setItem(key, end); } catch (e) {}
      }
      var tick = function () {
        var el = app.querySelector('[data-bq-timer]');
        if (!el) return;
        var s = Math.max(0, Math.round((end - Date.now()) / 1000));
        el.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ' : ' + String(s % 60).padStart(2, '0');
        if (s > 0) promoTimer = setTimeout(tick, 1000);
      };
      tick();
    }

    /* ---------- render + bind ---------- */
    /* see .bq-fade / .bq-veil in the CSS: the fade-in is a veil over the page that fades out, so the
       new screen underneath is never animated itself; both are dropped once they have played */
    function unfade() {
      var el = app.querySelector('.bq-fade');
      var old = root.querySelector('.bq-veil');
      if (old) old.parentNode.removeChild(old);
      var veil = document.createElement('div');
      veil.className = 'bq-veil';
      veil.setAttribute('aria-hidden', 'true');
      root.appendChild(veil);
      /* animationend plus a timer: if the animation never runs (background tab, headless, an app that
         disables animations) the veil must still never be left covering the page */
      var done = function () {
        if (veil.parentNode) veil.parentNode.removeChild(veil);
        if (el) el.classList.remove('bq-fade');
      };
      veil.addEventListener('animationend', done, { once: true });
      setTimeout(done, 700);
    }

    function render() {
      clearTimeout(loaderTimer);
      clearTimeout(promoTimer);
      busy = false;
      var cs = current();
      root.classList.toggle('is-landing', !cs);
      root.classList.toggle('is-checkout', !!cs && cs.type === 'checkout');
      parkFrontrow();
      if (!cs) {
        app.innerHTML = vLanding();
        unfade();
        mountFrontrow();
        bindLanding();
        window.scrollTo(0, 0);
        return;
      }
      if ((cs.type === 'post' || cs.type === 'checkout') && !results) computeResults();

      var postLike = { loader: 1, email: 1, post: 1, checkout: 1 }[cs.type];
      var views = { single: vSingle, multi: vMulti, bodymap: vBodymap, info: vInfo, height: vHeight, weight: vWeight, loader: vLoader, email: vEmail, post: vPost, checkout: vCheckout };
      app.innerHTML = header(postLike ? 'post' : 'q') +
        '<div class="bq-screen bq-fade' + (postLike ? ' bq-screen--post' : '') + '" data-step="' + esc(cs.id) + '">' + views[cs.type](cs) + '</div>';
      window.scrollTo(0, 0);
      unfade();
      if (live) live.textContent = cs.title || '';
      track('quiz_step_viewed');

      var backBtn = app.querySelector('[data-bq-back]');
      if (backBtn) backBtn.addEventListener('click', back);

      if (cs.type === 'single') bindSingle(cs);
      else if (cs.type === 'multi') bindMulti(cs);
      else if (cs.type === 'bodymap') { paintBody(); bindBody(cs); }
      else if (cs.type === 'height') bindHeight();
      else if (cs.type === 'weight') bindWeight();
      else if (cs.type === 'loader') runLoader(cs);
      else if (cs.type === 'email') bindEmail();
      else if (cs.type === 'checkout') bindCheckout();
      if (cs.type === 'info') syncInfoCopy();

      var nx = app.querySelector('[data-bq-next]');
      if (nx) nx.addEventListener('click', function () {
        if (nx.disabled) return;
        track('quiz_question_answered', { answer: label(cs.id, answers[cs.id]) });
        next();
      });
    }

    function syncInfoCopy() {
      var p = app.querySelector('.bq-info-intro');
      if (!p) return;
      var mq = window.matchMedia('(max-width: 749px)');
      var set = function () { p.textContent = mq.matches ? p.getAttribute('data-mob') : p.getAttribute('data-desk'); };
      set();
    }

    function bindLanding() {
      app.querySelectorAll('[data-bq-age]').forEach(function (b) {
        b.addEventListener('click', function () {
          answers.age = +b.getAttribute('data-bq-age');
          answers.gender = 'male';
          track('quiz_started', { age: label('age', answers.age) });
          go(0);
        });
      });
      app.querySelectorAll('[data-bq-gender]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.getAttribute('data-bq-gender');
          /* the two body maps have different areas - a switched gender starts the map over */
          if (answers.gender && answers.gender !== g) delete answers.areas;
          answers.gender = g;
          track('quiz_started', { gender: answers.gender });
          go(0);
        });
      });
    }

    function bindSingle(s) {
      app.querySelectorAll('[data-bq-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (busy) return;
          busy = true;
          answers[s.id] = +b.getAttribute('data-bq-opt');
          app.querySelectorAll('[data-bq-opt]').forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-checked', on);
          });
          track('quiz_question_answered', { answer: label(s.id, answers[s.id]) });
          setTimeout(next, 260);
        });
      });
    }

    function bindMulti(s) {
      var nx = app.querySelector('[data-bq-next]');
      var none = s.none || [];
      app.querySelectorAll('[data-bq-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = +b.getAttribute('data-bq-opt');
          var v = Array.isArray(answers[s.id]) ? answers[s.id].slice() : [];
          if (none.indexOf(i) !== -1) v = v.indexOf(i) !== -1 ? [] : [i];
          else {
            v = v.filter(function (x) { return none.indexOf(x) === -1; });
            v = v.indexOf(i) !== -1 ? v.filter(function (x) { return x !== i; }) : v.concat(i);
          }
          answers[s.id] = v;
          app.querySelectorAll('[data-bq-opt]').forEach(function (x) {
            var on = v.indexOf(+x.getAttribute('data-bq-opt')) !== -1;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-checked', on);
          });
          nx.disabled = !v.length;
        });
      });
    }

    function bindBody(s) {
      var nx = app.querySelector('[data-bq-next]');
      app.querySelectorAll('[data-bq-area]').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-bq-area');
          var v = Array.isArray(answers[s.id]) ? answers[s.id].slice() : [];
          v = v.indexOf(k) !== -1 ? v.filter(function (x) { return x !== k; }) : v.concat(k);
          answers[s.id] = v;
          b.classList.toggle('is-on', v.indexOf(k) !== -1);
          b.setAttribute('aria-pressed', v.indexOf(k) !== -1);
          nx.disabled = !v.length;
          paintBody();
        });
      });
      app.querySelectorAll('.bq-bm-part').forEach(function (p) {
        p.style.cursor = 'pointer';
        p.addEventListener('click', function () {
          var tag = app.querySelector('[data-bq-area="' + p.getAttribute('data-area') + '"]');
          if (tag) tag.click();
        });
      });
    }

    function bindUnits() {
      app.querySelectorAll('[data-bq-units]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (units === b.getAttribute('data-bq-units')) return;
          units = b.getAttribute('data-bq-units');
          render();
        });
      });
    }

    function fieldWatch(submit, errBox) {
      var inputs = app.querySelectorAll('.bq-field input');
      var sync = function () {
        var filled = true;
        inputs.forEach(function (inp) {
          inp.parentNode.classList.toggle('is-filled', inp.value !== '');
          inp.parentNode.classList.remove('is-error');
          if (inp.value === '' && inp.id !== 'bq-in') filled = false;
        });
        errBox.hidden = true;
        submit.disabled = !filled;
      };
      inputs.forEach(function (inp) {
        inp.addEventListener('input', function () {
          /* whole numbers only, like Bioma: strip anything that is not a digit */
          var clean = inp.value.replace(/\D/g, '').slice(0, +inp.getAttribute('data-len') || 3);
          if (clean !== inp.value) inp.value = clean;
          /* feet is one digit: a valid 4–6 moves straight on to inches */
          if (inp.id === 'bq-ft' && /^[4-6]$/.test(clean)) { var nx = app.querySelector('#bq-in'); if (nx) nx.focus(); }
          sync();
        });
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && !submit.disabled) submit.click();
          /* number inputs reject 5'10" — a foot mark (or space / dot) in Feet jumps to Inches instead */
          if (inp.id === 'bq-ft' && /^['’"″′ .,]$/.test(e.key)) {
            e.preventDefault();
            var next = app.querySelector('#bq-in');
            if (next) { next.focus(); next.select(); }
          }
        });
      });
      sync();
    }

    function showError(errBox, submit, msg, ids) {
      errBox.textContent = msg;
      errBox.hidden = false;
      submit.disabled = true;
      (ids || []).forEach(function (id) { var el = app.querySelector('#bq-' + id); if (el) el.parentNode.classList.add('is-error'); });
    }

    function bindHeight() {
      bindUnits();
      var submit = app.querySelector('[data-bq-submit]');
      var err = app.querySelector('[data-bq-error]');
      fieldWatch(submit, err);
      submit.addEventListener('click', function () {
        var cm;
        if (units === 'imperial') {
          var ft = parseFloat(app.querySelector('#bq-ft').value);
          var inch = parseFloat(app.querySelector('#bq-in').value || 0);
          if (isNaN(ft)) return showError(err, submit, 'Enter your height.', ['ft']);
          if (ft < 4 || ft > 6) return showError(err, submit, 'Please enter a height between 4’0” and 6’11”', ['ft']);
          if (inch < 0 || inch > 11) return showError(err, submit, 'Inches must be between 0 and 11.', ['in']);
          cm = Math.round(2.54 * (12 * ft + inch));
        } else {
          cm = Math.round(parseFloat(app.querySelector('#bq-cm').value));
          if (!cm || cm < 140 || cm > 220) return showError(err, submit, 'Please enter a height between 140 and 220 cm', ['cm']);
        }
        answers.height = { cm: cm };
        track('quiz_question_answered', { answer: cm + ' cm' });
        next();
      });
    }

    function heightLabel(cm) {
      if (units === 'metric') return cm + ' cm';
      var t = Math.round(cm / 2.54);
      return Math.floor(t / 12) + '’' + (t % 12) + '”';
    }

    function bindWeight() {
      bindUnits();
      var submit = app.querySelector('[data-bq-submit]');
      var err = app.querySelector('[data-bq-error]');
      fieldWatch(submit, err);
      submit.addEventListener('click', function () {
        var f = units === 'imperial' ? 2.2046 : 1;
        var u = units === 'imperial' ? 'lbs' : 'kg';
        var lo = units === 'imperial' ? 88 : 40, hi = units === 'imperial' ? 550 : 250;
        var c = parseFloat(app.querySelector('#bq-cw').value);
        var g = parseFloat(app.querySelector('#bq-gw').value);
        if (!c || !g) return showError(err, submit, 'Enter both your current and goal weight.', [!c ? 'cw' : 'gw']);
        if (c < lo || c > hi) return showError(err, submit, 'Current weight must be between ' + lo + ' and ' + hi + ' ' + u + '.', ['cw']);
        if (g < lo || g > hi) return showError(err, submit, 'Goal weight must be between ' + lo + ' and ' + hi + ' ' + u + '.', ['gw']);
        if (g >= c) return showError(err, submit, 'Goal weight must be less than current weight', ['gw']);
        var hcm = (answers.height && answers.height.cm) || 170;
        if ((g / f) / Math.pow(hcm / 100, 2) < 18.5) {
          return showError(err, submit, 'Sorry, based on the entered height of ' + heightLabel(hcm) + ', OMNI is not currently designed to reach the entered goal weight, following World Health Organization (WHO) guidelines that classify BMIs below 18.5 as underweight.', ['gw']);
        }
        answers.weight = { current: c / f, goal: g / f, units: units };
        results = null;
        track('quiz_question_answered', { answer: c + ' → ' + g + ' ' + u });
        next();
      });
    }

    function bindEmail() {
      var form = app.querySelector('[data-bq-email]');
      var inp = form.querySelector('input');
      var submit = form.querySelector('button');
      var valid = function () { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inp.value.trim()); };
      var sync = function () {
        inp.parentNode.classList.toggle('is-filled', inp.value !== '');
        inp.parentNode.classList.remove('is-error');
      };
      inp.addEventListener('input', sync);
      sync();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!valid()) {
          inp.parentNode.classList.add('is-error');
          inp.focus();
          return;
        }
        answers.email = inp.value.trim();
        if (!results) computeResults();
        pushLead();
        track('quiz_lead');
        next();
      });
    }

    function bindCheckout() {
      startTimer();
      track('quiz_result_viewed', { tier: results.tier, plan: results.plan });
      app.querySelectorAll('[data-bq-flavor]').forEach(function (b) {
        b.addEventListener('click', function () {
          flavor = b.getAttribute('data-bq-flavor');
          app.querySelectorAll('[data-bq-flavor]').forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-checked', on);
          });
          app.querySelectorAll('[data-bq-order]').forEach(function (a) { a.href = cartLink(a.getAttribute('data-bq-order')); });
        });
      });
      app.querySelectorAll('[data-bq-order]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var p = a.getAttribute('data-bq-order');
          track('quiz_cta_clicked', { plan: p, pack: STORE.cards[p].pack, qty: STORE.cards[p].qty, selling_plan: STORE.cards[p].plan, flavor: flavor });
          if (!window.fetch || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
          ev.preventDefault();
          orderNow(p, a);
        });
      });
    }

    /* Test link: ?bq_step=checkout (or p1-p7, email, any question id) fills the quiz with sample
       answers and opens that screen directly. Nothing is tracked or sent to Klaviyo for it. */
    function jumpTo(id) {
      previewJump = true;
      answers.gender = F.id === 'men' ? 'male' : 'female';
      if (F.id === 'men') answers.age = 0;
      F.steps.forEach(function (s) {
        if (s.type === 'single') answers[s.id] = 0;
        else if (s.type === 'multi') answers[s.id] = [0];
        else if (s.type === 'bodymap') answers[s.id] = AREAS[sex()].slice(0, 2).map(function (a) { return a.key; });
        else if (s.type === 'height') answers[s.id] = { cm: 168 };
        else if (s.type === 'weight') answers[s.id] = { current: 175 / 2.2046, goal: 150 / 2.2046, units: 'imperial' };
      });
      var post = POST.some(function (s) { return s.id === id; });
      if (post) answers.email = 'preview@example.com';
      computeResults();
      var list = visible(), idx = -1;
      for (var i = 0; i < list.length; i++) if (list[i].id === id) idx = i;
      step = idx;
    }
    var jump = null;
    try { jump = new URLSearchParams(window.location.search).get('bq_step'); } catch (e) {}
    if (jump && /^[a-z0-9_-]{1,40}$/i.test(jump)) jumpTo(jump);

    try { history.replaceState({ bq: step }, ''); } catch (e) {}
    render();
  }

  function boot() { document.querySelectorAll('[data-omni-quiz-v4]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
